import { useEffect, useState, useCallback } from "react";
import { getVitalsByHistorytId } from "../../api/historyService";
import { getVitalsByHistoryEntrytId } from "../../api/historyService";
import { getVitalsByPetId } from "../../api/historyService";
export const useHistoryVitals = (historyId, entryId, petId, mode, trigger, initialPage = 1, initialLimit = 10) => {
    const [vitals, setDcoumentations] = useState({
        data: [],
        pagination: { page: initialPage, limit: initialLimit, totalPages: 1, total: 0 },
        sort: null,
        search: null,
    });
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchData = useCallback(
        async (page = initialPage, limit = initialLimit, append = false, search = searchTerm) => {
            setLoading(true);
            try {
              let response;
              if (mode === 'pet') {
                response = await getVitalsByPetId(petId, page, limit);
              }
              else {
                if (entryId)
                {
                  response = await getVitalsByHistoryEntrytId(entryId, page, limit);
                }
                else {
                  response = await getVitalsByHistorytId(historyId, page, limit);
                }
              }
              setDcoumentations(prev => {
              if (append) {
                  return {
                  ...response,
                  data: [...(prev.data || []), ...response.data],
                  };
              }
              // 🔑 Reset pagination when not appending (fresh search or initial load)
              return {
                  ...response,
                  pagination: { ...response.pagination, page }, 
              };
              });
              return response;
            } catch (err) {
                console.error("Failed to fetch inventory items:", err);
            } finally {
                setLoading(false);
            }
        },
        [initialPage, initialLimit, searchTerm]
    );

    useEffect(() => {
        fetchData(initialPage, initialLimit, false, searchTerm);
    }, [trigger, fetchData, initialPage, initialLimit, searchTerm]);

    const loadMore = async () => {
        const nextPage = vitals.pagination.page + 1;
        if (nextPage <= vitals.pagination.totalPages) {
        await fetchData(nextPage, vitals.pagination.limit, true, searchTerm);
        }
    };

    // 🔎 Called by SearchBox
    const searchFunction = async (page, keywords) => {
        setSearchTerm(keywords);
        // Reset results and pagination when searching
        await fetchData(page, vitals.pagination.limit, false, keywords);
    };

    const resetParent = async () => {
        setSearchTerm("");
        await fetchData(initialPage, initialLimit, false, "");
    };

    return { vitals, loading, loadMore, searchFunction, resetParent };
};